import { addDoc, collection, deleteDoc, doc, updateDoc } from "firebase/firestore";
import { limit as liteLimit, orderBy as liteOrderBy, where as liteWhere } from "firebase/firestore/lite";
import { FAQ } from "../../models/FAQ";
import db from "../Firebase.js";
import { fetchFAQQuestions, invalidateFAQCache } from "../../helpers/faqQuery.ts";
import { getLiteQueryDocs } from "../../helpers/firestoreLiteQuery.ts";

async function getNextQuestionOrder(): Promise<number> {
    const docs = await getLiteQueryDocs('questions', [
        liteOrderBy('order', 'desc'),
        liteLimit(1),
    ]);

    if (docs.length === 0) {
        return 1;
    }

    const maxOrder = Number(docs[0].data().order ?? 0);
    return maxOrder + 1;
}


export async function addQuestion(newQuestion: { title: string; content: string }): Promise<void> {
    const nextQuestionOrder = await getNextQuestionOrder();
    const questionWithOrder = { ...newQuestion, order: nextQuestionOrder };
    await addDoc(collection(db, 'questions'), questionWithOrder);
    invalidateFAQCache();
}

export async function showFAQ(): Promise<FAQ[]> {
    return fetchFAQQuestions();
}

export async function getQuestionIdByTitleAndContent(title: string, content: string) {
    const docs = await getLiteQueryDocs('questions', [
        liteWhere('title', '==', title),
        liteWhere('content', '==', content),
    ]);
    let questionId = '';
    docs.forEach((docSnap) => {
        questionId = docSnap.id;
    });
    return questionId;
}

export async function editQuestion(questionId: string, updatedQuestion: Pick<FAQ, "title" | "content">): Promise<void> {
    const questionDoc = doc(db, 'questions', questionId);
    await updateDoc(questionDoc, updatedQuestion);
    invalidateFAQCache();
}

export async function deleteQuestion(title: string, content: string) {
    const docs = await getLiteQueryDocs('questions', [
        liteWhere('title', '==', title),
        liteWhere('content', '==', content),
    ]);
    
    if (docs.length > 0) {
        const questionId = docs[0].id;
        await deleteDoc(doc(db, 'questions', questionId));
        invalidateFAQCache();
    }
}
